import './styles/card.styles.scss';

export const Card: React.FC = props => {
    return <div className='card'>{props.children}</div>;
};
